import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { images } from '../../data/site';
export function Hero() {
  return <section className="relative isolate overflow-hidden" data-id="element-109" data-mp="joykhy2bsy2m">
      <img src={images.hero} alt="Jardin entretenu avec pelouse tondue, haies taillées et massifs fleuris" className="absolute inset-0 -z-10 h-full w-full object-cover" data-id="element-110" data-mp="jnf3u6crcl0b" />
      <div className="absolute inset-0 -z-10 bg-forest-dark/55" aria-hidden="true" data-id="element-111" data-mp="apv08qrfacmj" />

      <div className="mx-auto flex min-h-[640px] max-w-7xl flex-col justify-end px-5 pb-16 pt-32 md:min-h-[720px] md:px-8 md:pb-24" data-id="element-112" data-mp="5nvvpdjy59o0">
        <p className="flex items-center gap-2 text-sm font-medium text-cream/90" data-id="element-113" data-mp="s73xwe64x29">
          <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="3ryi29krsnjpw" />
          Champcueil et alentours, Essonne
        </p>
        <h1 className="mt-5 max-w-4xl font-serif text-5xl font-medium leading-[1.05] text-white md:text-7xl" data-id="element-115" data-mp="1v210os0ijlm9">
          Un jardin bien tenu, sans y passer vos week-ends.
        </h1>
        <p className="mt-6 max-w-xl text-lg leading-relaxed text-cream/90" data-id="element-116" data-mp="1myfbvo838sip">
          Vincent Monti, jardinier paysagiste à Champcueil. Entretien, taille, tonte et
          aménagement de jardins pour les particuliers du sud de l’Essonne.
        </p>
        <div className="mt-10 flex flex-wrap gap-3" data-id="element-117" data-mp="1hwg84d8frtl8">
          <a href="#devis" className="inline-flex items-center gap-2 rounded-full bg-clay px-6 py-3.5 text-sm font-medium text-white transition-colors duration-150 hover:bg-clay-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-118" data-mp="1hzc7m5zxmqbs">
            Demander un devis gratuit
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-119" data-mp="20vu6r8h41si2" />
          </a>
          <Link to="/prestations" className="inline-flex items-center rounded-full border border-white/60 px-6 py-3.5 text-sm font-medium text-white transition-colors duration-150 hover:bg-white/10" data-id="element-120" data-mp="20tr67uic0gz3">
            Voir les prestations
          </Link>
        </div>
      </div>
    </section>;
}